import React from 'react';
import { Badge, Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import UploadMassal from './Massal';
import UploadSatuan from './Satuan';

export default function UploadProduct({ ...props }) {
    return (
        <Box bg={'semantic.100'} boxShadow={'0px 1px 3px 0px #0000001A'} borderRadius={'8px'} p="20px" {...props}>
            <Tabs>
                <TabList>
                    <Tab>Upload Massal</Tab>
                    <Tab>
                        Upload Satuan
                        <Badge
                            rounded={'full'}
                            textTransform={'capitalize'}
                            color={'semantic.100'}
                            bg={'danger.500'}
                            p={'4px 6px'}
                            ml={'8px'}
                        >
                            Baru!
                        </Badge>
                    </Tab>
                </TabList>
                <TabPanels>
                    <TabPanel pb={'0'}>
                        <UploadMassal />
                    </TabPanel>
                    <TabPanel pb={'0'}>
                        <UploadSatuan />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
}
